import mailStore from 'owa-mail-store/lib/store/Store';
import { mutator } from 'satcheljs';
import flagItemsStoreUpdate from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';

export default mutator(flagItemsStoreUpdate, actionMessage => {
    const itemIds: string[] = actionMessage.itemIds;

    // Update flag status on items
    itemIds.forEach(itemId => {
        const item = mailStore.items.get(itemId);
        item.Flag = { FlagStatus: actionMessage.flagTypeToSet.FlagStatus };
    });
});
